import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/joris_broll.jpg'
import _imports_1 from '@/assets/fr.svg'
import _imports_2 from '@/assets/technologies/react-logo.png'
import _imports_3 from '@/assets/technologies/typescript-logo.png'
import _imports_4 from '@/assets/technologies/contenful-logo.png'
import _imports_5 from '@/assets/technologies/graphql-logo.png'
import _imports_6 from '@/assets/references/nbc/new_body_concept.png'
import _imports_7 from '@/assets/references/gss/gites_spa_strasbourg.png'
import _imports_8 from '@/assets/references/lb/laurette_broll.png'
import _imports_9 from '@/assets/references/naveco/naveco.png'


const _withScopeId = n => (_pushScopeId("data-v-786fa2af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white w-[21cm] h-[29.7cm] text-black overflow-hidden" }
const _hoisted_2 = {
  class: "p-6 text-center",
  style: {"background-image":"linear-gradient(135deg, rgba(230,230,230) 5.56%, rgba(0,0,0,0) 5.56%, rgba(0,0,0,0) 50%, rgba(230,230,230) 50%, rgba(230,230,230) 55.56%, rgba(0,0,0,0) 55.56%, rgba(0,0,0,0) 100%)","background-size":"12.73px 12.73px"}
}
const _hoisted_3 = { class: "flex flex-row justify-between items-center gap-x-20 px-5 py-5 rounded-lg bg-white/75 drop-shadow-xl" }
const _hoisted_4 = { class: "flex-none text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-32 mx-auto mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-full drop-shadow-lg",
    src: _imports_0,
    alt: "Joris BROLL"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute bottom-0 right-0 rounded-full w-8",
    src: _imports_1
  })
], -1))
const _hoisted_6 = { class: "text-xs text-left space-y-1 inline-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 inline-block mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"fill":"black"},
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 inline-block mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"fill":"black"},
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-3 inline-block mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    style: {"fill":"black"},
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M207.8 20.73c-93.45 18.32-168.7 93.66-187 187.1c-27.64 140.9 68.65 266.2 199.1 285.1c19.01 2.888 36.17-12.26 36.17-31.49l.0001-.6631c0-15.74-11.44-28.88-26.84-31.24c-84.35-12.98-149.2-86.13-149.2-174.2c0-102.9 88.61-185.5 193.4-175.4c91.54 8.869 158.6 91.25 158.6 183.2l0 16.16c0 22.09-17.94 40.05-40 40.05s-40.01-17.96-40.01-40.05v-120.1c0-8.847-7.161-16.02-16.01-16.02l-31.98 .0036c-7.299 0-13.2 4.992-15.12 11.68c-24.85-12.15-54.24-16.38-86.06-5.106c-38.75 13.73-68.12 48.91-73.72 89.64c-9.483 69.01 43.81 128 110.9 128c26.44 0 50.43-9.544 69.59-24.88c24 31.3 65.23 48.69 109.4 37.49C465.2 369.3 496 324.1 495.1 277.2V256.3C495.1 107.1 361.2-9.332 207.8 20.73zM239.1 304.3c-26.47 0-48-21.56-48-48.05s21.53-48.05 48-48.05s48 21.56 48 48.05S266.5 304.3 239.1 304.3z" })
  ]),
  /*#__PURE__*/_createTextVNode("joris.broll@gmail.com")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-3 inline-block mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    style: {"fill":"black"},
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" })
  ]),
  /*#__PURE__*/_createTextVNode("+33 6 76 66 50 45")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-3 inline-block mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    style: {"fill":"black"},
    viewBox: "0 0 640 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M172.5 131.1C228.1 75.51 320.5 75.51 376.1 131.1C426.1 181.1 433.5 260.8 392.4 318.3L391.3 319.9C381 334.2 361 337.6 346.7 327.3C332.3 317 328.9 297 339.2 282.7L340.3 281.1C363.2 249 359.6 205.1 331.7 177.2C300.3 145.8 249.2 145.8 217.7 177.2L105.5 289.5C73.99 320.1 73.99 372 105.5 403.5C133.3 431.4 177.3 435 209.3 412.1L210.9 410.1C225.3 400.7 245.3 404 255.5 418.4C265.8 432.8 262.5 452.8 248.1 463.1L246.5 464.2C188.1 505.3 110.2 498.7 60.21 448.8C3.741 392.3 3.741 300.7 60.21 244.3L172.5 131.1zM467.5 380C411 436.5 319.5 436.5 263 380C213 330 206.5 251.2 247.6 193.7L248.7 192.1C258.1 177.8 278.1 174.4 293.3 184.7C307.7 194.1 311.1 214.1 300.8 229.3L299.7 230.9C276.8 262.1 280.4 306.9 308.3 334.8C339.7 366.2 390.8 366.2 422.3 334.8L534.5 222.5C566 191 566 139.1 534.5 108.5C506.7 80.63 462.7 76.99 430.7 99.9L429.1 101C414.7 111.3 394.7 107.1 384.5 93.58C374.2 79.2 377.5 59.21 391.9 48.94L393.5 47.82C451 6.731 529.8 13.25 579.8 63.24C636.3 119.7 636.3 211.3 579.8 267.7L467.5 380z" })
  ]),
  /*#__PURE__*/_createTextVNode("joris-broll.com")
], -1))
const _hoisted_12 = { class: "text-center justify-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-[#4b89a6]" }, "Joris BROLL", -1))
const _hoisted_14 = { class: "mb-4 text-neutral-600" }
const _hoisted_15 = { class: "text-sm mb-6 px-4 mx-auto text-justify" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-white rounded-full h-9 px-1 py-1 drop-shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-full",
      src: _imports_2,
      alt: "React JS"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9 drop-shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "rounded-full h-full",
      src: _imports_3,
      alt: "Typescript"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9 drop-shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "rounded-full h-full",
      src: _imports_4,
      alt: "Contentful"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9 drop-shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "bg-white rounded-full h-full p-1",
      src: _imports_5,
      alt: "GraphQL"
    })
  ])
], -1))
const _hoisted_17 = { class: "flex px-6 gap-x-10 mt-4" }
const _hoisted_18 = { class: "w-[200px] flex-shrink-0" }
const _hoisted_19 = { class: "uppercase text-[#3d366d] text-center border-b border-neutral-400 pb-1 mb-3 text-sm" }
const _hoisted_20 = { class: "space-y-6 px-2" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "Front-end", -1))
const _hoisted_23 = { class: "text-xs dashes" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "React", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Typescript"),
  /*#__PURE__*/_createTextVNode(" · JavaScript (ES6)")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "HTML", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Unit Testing et E2E Testing avec Jest et Mocha", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "TailwindCSS"),
  /*#__PURE__*/_createTextVNode(" · Bootstrap · etc")
], -1))
const _hoisted_29 = { class: "" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "Back-End", -1))
const _hoisted_31 = { class: "text-xs dashes" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "NodeJS"),
  /*#__PURE__*/_createTextVNode(" · "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "PHP"),
  /*#__PURE__*/_createTextVNode(" · Ruby")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "GraphQL"),
  /*#__PURE__*/_createTextVNode(" APIs · "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "REST"),
  /*#__PURE__*/_createTextVNode(" APIs")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Headless CMS : "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Contentful"),
  /*#__PURE__*/_createTextVNode(" · Strapi")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "AWS"),
  /*#__PURE__*/_createTextVNode(" · Heroku · Google Cloud")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Linux · Nginx · PM2", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "MySQL · PostgreSQL · MongoDB", -1))
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "text-[#00aeff] text-sm mb-1" }
const _hoisted_40 = { class: "text-xs dashes" }
const _hoisted_41 = { class: "font-bold" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Proactif et force de proposition", -1))
const _hoisted_43 = { class: "font-bold" }
const _hoisted_44 = { class: "uppercase text-[#3d366d] text-center border-b border-neutral-400 pb-1 mb-4 text-sm" }
const _hoisted_45 = {
  key: 0,
  class: "text-xs px-2"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "2019 - Aujourd'hui : Développeur web Full-Stack", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 mb-1" }, "Création administration et hébergement de sites Internet", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "mb-6 dashes" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Définition de besoin client, architecture de projet et de données et création du project."),
  /*#__PURE__*/_createElementVNode("li", null, "Sites vitrines et e-commerce."),
  /*#__PURE__*/_createElementVNode("li", null, "Gestion de projet et de clientèle calqués sur les méthodes Agile et DevOps."),
  /*#__PURE__*/_createElementVNode("li", null, "Connaissances étendues de Typescript, Vue, GraphQL, PostGre entre autres."),
  /*#__PURE__*/_createElementVNode("li", null, "Logiciels Web pour gestion d'entreprise."),
  /*#__PURE__*/_createElementVNode("li", null, "Gestion de code et deploiement via Git.")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "2017 - 2019 : Entrepreneur chez Black Owl Studio", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Expérience en gestion d'entreprise et gestion de projet.")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "2011-2016 : Développeur Web chez Groupe Éléphant", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 mb-1" }, "Agence de Communication à Belfort", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "dashes" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Création et administration de nombreux sites en "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "PHP"),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Création de plug-ins PHP pour WordPress et Prestashop."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Création d'"),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "applications mobiles pour Android et iPhone.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Creation de l'"),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "API back-end en Ruby"),
    /*#__PURE__*/_createTextVNode(" pour les applications susmentionnées.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Gestion de l'ensemble de l'infrastructure web de l'agence, un serveur dédié Linux et un serveur Web Apache."),
  /*#__PURE__*/_createElementVNode("li", null, "Dernière année : Gestion de projets et de la relation clientelle.")
], -1))
const _hoisted_54 = { class: "text-center mt-6 mb-3 text-[#4b89a6] px-4" }
const _hoisted_55 = {
  key: 1,
  class: "text-xs px-2"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "2019 - Today"),
  /*#__PURE__*/_createTextVNode(" : Remote Freelance Full-Stack web developer")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "mb-6 dashes" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Creating Showcase and E-shop websites."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Creating "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Web softwares"),
    /*#__PURE__*/_createTextVNode(" for company management.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Project management"),
    /*#__PURE__*/_createTextVNode(" : definition of user needs, project and data architecture, site maintenance, user feedback...")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Advanced usage of "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "NodeJS"),
    /*#__PURE__*/_createTextVNode(", React, Vue, Typescript, GraphQL and PostgreSQL among other technologies.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Linux server config and management (Web server, reverse-proxy, firewall, etc.)"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Git"),
    /*#__PURE__*/_createTextVNode("-integrated workflow and DevOps-inspired project management philosophy.")
  ])
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "2017 - 2019"),
  /*#__PURE__*/_createTextVNode(" : Entrepreneur at Black Owl Studio")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Experience in managing a company and accomplishing long-term goals.")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "2011-2016"),
  /*#__PURE__*/_createTextVNode(" : Junior Web developer at Groupe Éléphant")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 mb-1" }, "Communication agency based in Belfort, France.", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "dashes" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Created "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "mobile applications for Android and iPhone.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Integrated websites from Photoshop Mockups."),
  /*#__PURE__*/_createElementVNode("li", null, "Created websites and web plugins using PHP and Ruby."),
  /*#__PURE__*/_createElementVNode("li", null, "Created Ruby back-end API for aforementioned applications."),
  /*#__PURE__*/_createElementVNode("li", null, "Managed the agency's web servers infrastructure."),
  /*#__PURE__*/_createElementVNode("li", null, "During the last year : managed customer projects and relationships.")
], -1))
const _hoisted_63 = { class: "text-center mt-6 mb-3 text-[#4b89a6] px-3" }
const _hoisted_64 = { class: "flex px-6 gap-x-10 mt-5" }
const _hoisted_65 = { class: "w-[200px] flex-shrink-0" }
const _hoisted_66 = { class: "uppercase text-[#3d366d] text-center border-b border-neutral-400 p-1 mb-3 text-sm" }
const _hoisted_67 = { class: "text-xs space-y-3" }
const _hoisted_68 = { class: "rounded px-2 py-1" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "2012", -1))
const _hoisted_70 = { class: "rounded px-2 py-1" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[#00aeff] text-sm mb-1" }, "2010 - 2011", -1))
const _hoisted_72 = { class: "uppercase text-[#3d366d] text-center border-b border-neutral-400 p-1 mb-8 text-sm" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex gap-8 justify-center text-center px-2" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "basis-1/4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "aspect-square object-contain bg-neutral-200/25 rounded-full mb-2 mx-auto w-full",
      src: _imports_6
    }),
    /*#__PURE__*/_createElementVNode("figcaption", { class: "text-sm" }, [
      /*#__PURE__*/_createTextVNode("newbody"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("concept.ch")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("figure", { class: "basis-1/4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "aspect-square object-contain bg-neutral-200/25 p-1 rounded-full mb-2 mx-auto w-full",
      src: _imports_7
    }),
    /*#__PURE__*/_createElementVNode("figcaption", { class: "text-sm" }, "gites-spa-strasbourg.fr")
  ]),
  /*#__PURE__*/_createElementVNode("figure", { class: "basis-1/4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "aspect-square object-contain bg-neutral-200/25 p-1 rounded-full mb-2 mx-auto w-full",
      src: _imports_8
    }),
    /*#__PURE__*/_createElementVNode("figcaption", { class: "text-sm" }, "laurette-broll.fr")
  ]),
  /*#__PURE__*/_createElementVNode("figure", { class: "basis-1/4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "aspect-square object-contain bg-neutral-200/25 rounded-full mb-2 mx-auto w-full",
      src: _imports_9
    }),
    /*#__PURE__*/_createElementVNode("figcaption", { class: "text-sm" }, [
      /*#__PURE__*/_createTextVNode("github.com/"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("JorisBroll"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("/uber-clone")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JbMainContainer = _resolveComponent("JbMainContainer")!
  const _component_LocaleSwitch = _resolveComponent("LocaleSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_JbMainContainer, {
      p: "0",
      bg: "bg-black"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, [
                    _hoisted_7,
                    _createTextVNode(_toDisplayString(_ctx.$t('profile.age', { number : _ctx.myAge })), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_8,
                    _createTextVNode(_toDisplayString(_ctx.$t('profile.driver_licence')), 1)
                  ]),
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('title')), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('small_intro_fullstack')), 1),
                _hoisted_16
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t('skills.title')), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("ul", _hoisted_23, [
                    _createElementVNode("li", null, [
                      _hoisted_24,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('words.and')) + " Next.js", 1)
                    ]),
                    _hoisted_25,
                    _createElementVNode("li", null, [
                      _hoisted_26,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('words.and')) + " CSS", 1)
                    ]),
                    _hoisted_27,
                    _hoisted_28
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("ul", _hoisted_31, [
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _hoisted_35,
                    _hoisted_36,
                    _hoisted_37,
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.agile')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.$t('skills.other')), 1),
                  _createElementVNode("ul", _hoisted_40, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.autonomous')), 1),
                    _createElementVNode("li", null, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('skills.team_player')), 1)
                    ]),
                    _hoisted_42,
                    _createElementVNode("li", null, [
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('skills.lang_en')), 1)
                    ]),
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('skills.lang_de')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.$t('career.title')), 1),
              (_ctx.$i18n.locale == 'fr')
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _hoisted_47,
                    _hoisted_48,
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51,
                    _hoisted_52,
                    _hoisted_53,
                    _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('please_visit', {url: 'https://joris-broll.com'})), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$i18n.locale == 'en')
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _hoisted_56,
                    _hoisted_57,
                    _hoisted_58,
                    _hoisted_59,
                    _hoisted_60,
                    _hoisted_61,
                    _hoisted_62,
                    _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('please_visit', {url: 'https://joris-broll.com'})), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h2", _hoisted_66, _toDisplayString(_ctx.$t('background.studies')), 1),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('career.licence')), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('career.dut')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_72, _toDisplayString(_ctx.$t('references.title')), 1),
              _hoisted_73
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_LocaleSwitch, { class: "absolute opacity-0" })
  ], 64))
}